import {EVOUCHER} from '../actions/const';

const birthMonthOptions = [
  {
    label: "January",
    value: 0
  },
  {
    label: "February",
    value: 1
  },
  {
    label: "March",
    value: 2
  },
  {
    label: "April",
    value: 3
  },
  {
    label: "May",
    value: 4
  },
  {
    label: "June",
    value: 5
  },
  {
    label: "July",
    value: 6
  },
  {
    label: "August",
    value: 7
  },
  {
    label: "September",
    value: 8
  },
  {
    label: "October",
    value: 9
  },
  {
    label: "November",
    value: 10
  },
  {
    label: "December",
    value: 11
  }
];

const genderOptions = [
  {
    value: "ALL",
    label: "All"
  },
  {
    value: "FEMALE",
    label: "Female"
  },
  {
    value: "MALE",
    label: "Male"
  }
];

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,

  // VOUCHER CONFIG
  showConfigModal: false,
  isLoadingConfig: false,
  isSaving: false,
  isActive: true,
  message: "",
  configParseObject: null,

  isLoadingVoucherLog: false,
  pointsLastUpdate: "",

  refreshTable: null,
  selectedData: null,
  formType: "",
  formId: "",

  isUploadingCSVFile: false,
  isUploadingCSVFileBlacklistedUser: false,
  isUploadingCSVFileEVScannerUser: false,
  isLoadingCronJobs: false,

  typeK: null,
  transactionType: [],
  cardType: [],
  pointType: null,
  deductPointType: null,
  birthMonth: null,
  birthMonthOptions: birthMonthOptions,
  tdd_birthMonthStartDate: "",
  tdd_birthMonthEndDate: "",
  campaignStartDate: "",
  campaignEndDate: "",
  requiredEarningAmount: "",
  deductPointAmount: "",
  maxVoucherQuantity: "",
  maxVoucherQuantityPerDay: "",
  maxVoucherQuantityPerUser: "",
  maxVoucherQuantityPerUserPerDay: "",
  welcomeDays: "",
  version: null,
  campaignCategory: null,
  title: "",
  promotionName: "",
  descriptions: "",
  whereToRedeem: "",
  evScannerUser: [],
  manualDispense: "",
  serialNumberPrefix: "",
  amount: "",
  promoOwnerCostCenter: "",
  promoCategory: null,
  nnsl_amount: "",
  nnc_amount: "",
  image: null,
  isShowForFirstTimeUsers: false,
  isShowRemainingQuantity: false,
  isRateRequired: false,
  isShowMerchantsOwnRedemptionOnly: false,

  sendPushNotification: [],
  earningPeriod: null,
  earningPeriodStartDate: "",
  earningPeriodEndDate: "",

  voucherValidityType: null,
  voucherValidityDays: "",
  voucherValidityHour: "",
  voucherValidityMinute: "",
  voucherValiditySecond: "",
  voucherValidityStartDate: "",
  voucherValidityEndDate: "",
  voucherValidityStartTime: "",
  voucherValidityEndTime: "",
  voucherValidityIsUseCalendarDay: false,

  rateTimeConfigHour: "",
  rateTimeConfigMinute: "",
  rateTimeConfigSecond: "",

  specificUser: [],
  blacklistedUser: [],

  gender: genderOptions[0],
  genderOptions,

  isCheckingEVoucherStatus: false,
  isStatusExpired: false
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case EVOUCHER:
    if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
      action.payload = {...initialState};
    }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/EVoucher.js